import {put, takeEvery, select} from 'redux-saga/effects';
import {
  CALCULATE_ADJUST,
  CALCULATE_ADJUST_SUCCESS,
  CREATE_ADJUST,
  OPEN_ADJUST_ERROR_MODAL,
  OPEN_ADJUST_SUCCESS_MODAL
} from 'store/orders/orderAdjust/action';
import {
  calculateOrderAdjust,
  createOrderAdjust
} from 'helpers/services/api/orders';
import {GET_ORDER} from 'store/orders/orderDetails/action';
import generateAdjustError from 'helpers/functionUtils/adjustHelper';

function* calculateAdjust({payload: {data, invoiceId}}) {
  try {
    const locationId = yield select((state) => state.user.locationId);
    const {data: calculationResult} = yield calculateOrderAdjust(invoiceId, {
      ...data,
      locationId
    });
    if (calculationResult) {
      yield put(CALCULATE_ADJUST_SUCCESS(calculationResult));
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}
function* createAdjust({payload: {data, invoiceId, orderId}}) {
  try {
    const locationId = yield select((state) => state.user.locationId);
    const {
      data: {status, error}
    } = yield createOrderAdjust(invoiceId, {
      ...data,
      locationId
    });
    if (status === 'Succeeded') {
      yield put(OPEN_ADJUST_SUCCESS_MODAL(true));
      yield put(GET_ORDER(orderId));
    } else if (error && error.code) {
      yield put(
        OPEN_ADJUST_ERROR_MODAL({isOpen: true, ...generateAdjustError(error)})
      );
    }
  } catch (error) {
    if (error?.response?.data?.error) {
      yield put(
        OPEN_ADJUST_ERROR_MODAL({
          isOpen: true,
          ...generateAdjustError(error.response.data.error)
        })
      );
    } else {
      yield put(
        OPEN_ADJUST_ERROR_MODAL({
          isOpen: true,
          title: 'Something went wrong',
          message: null
        })
      );
    }
    console.log('SAGA ERROR', error);
  }
}

function* orderAdjustSaga() {
  yield takeEvery(CALCULATE_ADJUST, calculateAdjust);
  yield takeEvery(CREATE_ADJUST, createAdjust);
}

export default orderAdjustSaga;
